import React from "react";
import { Table, Typography, Tag, Skeleton } from "antd";
import "./PermissionOverviewTable.scss";
import { formatCurrency, formatWithCommas } from "../../../assets/helpers";
import { useSelector } from "react-redux";
import { createStyles } from "antd-style";

const { Text } = Typography;

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});
const PermissionOverviewTable = ({ data, loading }) => {
  const { styles } = useStyle();
  const { format } = useSelector((state) => state.priceFormat);
  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 50,
      render: (text) =>
        loading ? <Skeleton.Input active size="small" /> : <Text>{text}</Text>,
      fixed: "left",
    },
    {
      title: "Case No.",
      dataIndex: "case_no",
      key: "case_no",
      width: 100,
      render: (text) =>
        loading ? <Skeleton.Input active size="small" /> : <Text>{text}</Text>,
      fixed: "left",
    },
    {
      title: "Pending",
      dataIndex: "pending_amount",
      key: "pepending_amountnding",
      width: 90,
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(Number(text || 0), format)
        ),
    },
    {
      title: "Recovered",
      dataIndex: "recovered_amount",
      key: "recovered_amount",
      width: 100,
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(Number(text || 0), format)
        ),
    },

    {
      title: "Intensity",
      dataIndex: "intensity",
      key: "intensity",
      width: 90,
      render: (text) =>
        loading ? <Skeleton.Input active size="small" /> : <Text>{text}</Text>,
    },
    {
      title: "Contactability",
      dataIndex: "contactability",
      key: "contactability",
      width: 60,
      render: (status) =>
        loading ? (
          <Skeleton.Input active size="small" />
        ) : (
          <Tag
            className="contactabilityBox"
            color={
              status === "Connected"
                ? ""
                : status === "Untouched"
                ? ""
                : "default"
            }
          >
            {status}
          </Tag>
        ),
    },
  ];

  return (
    <Table
      className={`${styles.customTable} permissionTable sticky_pagination`}
      columns={columns}
      dataSource={data}
      pagination={false}
      scroll={{ x: "max-content", y: 55 * 5 }}
    />
  );
};

export default PermissionOverviewTable;
